import { onMounted, onUnmounted } from "vue";
import { useTimelineMapStore } from "@features/Pages/TimelineMapPage/_js/app/store/timelineMapStore";

type NavType = "navigate" | "reload" | "back_forward" | "prerender";

export function useTimelinePersistence() {
    const store = useTimelineMapStore();

    function navType(): NavType {
        try {
            const [nav] = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];
            return (nav?.type as NavType) || "navigate";
        } catch {
            return "navigate";
        }
    }

    function shouldRestore(): boolean {
        return navType() === "reload";
    }

    function load() {
        if (!shouldRestore()) {
            return { savedActiveId: undefined as number | undefined, savedY: undefined as number | undefined, shouldRestore: false };
        }

        const savedActiveIdStr = sessionStorage.getItem("activeEpochId");
        const savedActiveId = savedActiveIdStr ? parseInt(savedActiveIdStr, 10) : undefined;

        const savedYStr = sessionStorage.getItem("timelineScrollY");
        const savedY = savedYStr ? parseInt(savedYStr, 10) : undefined;

        return { savedActiveId, savedY, shouldRestore: true };
    }

    function saveScrollY() {
        sessionStorage.setItem("timelineScrollY", String(window.scrollY));
    }

    function saveActive(id: number | null) {
        if (id != null) { sessionStorage.setItem("activeEpochId", String(id)); }
    }

    function clearScrollY() {
        sessionStorage.removeItem("timelineScrollY");
    }

    onMounted(() => {
        window.addEventListener("beforeunload", saveScrollY);
    });
    onUnmounted(() => {
        window.removeEventListener("beforeunload", saveScrollY);
        saveScrollY();
    });

    return { load, saveScrollY, saveActive, clearScrollY, shouldRestore };
}
